.sn-dynamic-content {
  // Center the heading + body text when `align="center"` is set on the block.
  // Applied to the main column so both the slotted heading and the body inherit it.
  &__main--center {
    text-align: center;
  }

  h2 {
    font-size: map-get($font-sizes, 2xl); // 24px (heading-4-sm)
    line-height: map-get($line-heights, lg); // 140% (heading-4-sm)

    @include desktop {
      font-size: map-get($font-sizes, 3xl); // 32px (heading-4-lg)
      line-height: map-get($line-heights, xl); // 130% (heading-4-lg)
    }
  }

  ul {
    list-style: disc inside;
    margin: 0 0 var(--spacing-md);
    padding-left: revert; // Restore default browser padding if it was reset above
  }

  // fill-guide text styles (p / h3 / h2)
  p {
    margin-bottom: 0;
    font-size: px-to-rem(14px);
    line-height: px-to-rem(20px);

    @include above(1200px) {
      font-size: px-to-rem(16px);
      line-height: px-to-rem(24px);
    }

    &:not(:last-child) {
      margin-bottom: px-to-rem(20px);

      @include above(1200px) {
        margin-bottom: px-to-rem(24px);
      }
    }
  }

  h3 {
    font-weight: 700;
    font-size: px-to-rem(16px);
    line-height: px-to-rem(24px);
    margin-bottom: px-to-rem(8px);

    @include above(960px) {
      font-size: px-to-rem(24px);
      line-height: px-to-rem(32px);
      margin-bottom: px-to-rem(16px);
    }
  }

  // picture wrapper — light background + padding
  picture {
    background: #f6f8fb;
    display: block;
    padding: px-to-rem(16px) px-to-rem(20px);
    margin-bottom: px-to-rem(32px);

    @include above(768px) {
      padding: px-to-rem(32px) px-to-rem(40px);
      margin-bottom: px-to-rem(48px);
    }

    @include above(1200px) {
      padding: px-to-rem(51px) px-to-rem(40px);
      margin-bottom: px-to-rem(64px);
    }
  }

  // illustration inside picture (img / .texture-illustration)
  img,
  .texture-illustration {
    max-width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
    border-radius: var(--radius-size-sm); // 4px

    @include above(768px) {
      border-radius: px-to-rem(6px); // no token for 6px
    }

    @include above(960px) {
      border-radius: var(--radius-size-sm); // back to 4px on desktop
      max-height: px-to-rem(481px);
    }

    @include above(1200px) {
      border-radius: var(--radius-size-md); // 8px
      max-height: px-to-rem(571px);
    }
  }
}
